
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconGeneralCross as ObiBeaconGeneralCrossElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-general-cross.js';
 
 
 

 
 export const ObiBeaconGeneralCross = createComponent({
   react: React,
   tagName: 'obi-beacon-general-cross',
   elementClass: ObiBeaconGeneralCrossElement,
   events: {
     
   }
  });
 
 